import React, { Component } from 'react';
import { Table, Form } from 'react-bootstrap';
import DeckGL from '@deck.gl/react';
import {PolygonLayer} from '@deck.gl/layers';
import {StaticMap, MapContext, NavigationControl} from 'react-map-gl';
import {MapboxLayer} from '@deck.gl/mapbox';
import Modal from "react-bootstrap/Modal";
import LotDetails from './LotDetails/LotDetails';
import ReservationForm from '../Admin/ReservatinForm/ReservationForm';

import mixin from '../../utils/mixin';

import { 
  getDevelopmentByCode, 
  getSettingsStatus, 
  getLotsByDevelopment, 
  getAgentsByUserCode, 
  addActivityLog,
  getStoriesByDevelopment,
  getSeparatorsByDevelopment,
} from '../../api/Api.js';

import NavPublicMenu from './NavPublicMenu/NavPublicMenu';

import './Main.scss';

const {methods} = mixin;

const MAPBOX_TOKEN = process.env.REACT_APP_MAP_BOX_TOKEN;
const DEVELOPMENT_CODE = process.env.REACT_APP_DEVELOPMENT_CODE;

const NAV_CONTROL_STYLE = {
  position: 'absolute',
  top: 10,
  left: 10
};

const MAX_PITCH = 90;
const INITIAL_PITCH = 45;

class Main extends Component {

  constructor(props){
    
    super(props);

    this.tooltipRef = React.createRef();

    this.state = {
      user_code: null,
      agents: [],
      selected_agent: null,
      error_msg: null,
      hoverInfo : null,
      gl: null,
      isHovering: false,
      modalOpen: false,
      modalOpen2: false,
      loading: false,
      lots: [],
      stories: [],
      separators: [],
      action: null,
      selected_lot: null,
      development: null,
      development_id: null,
      status_array: [],
      show2D: false,
      showSatelliteMap: false,
      polygonExtruded: true,
      deckGLPitch: INITIAL_PITCH,
      deckGLInitialState: {
        longitude: -99.13293143846279,
        latitude: 19.43276303911265,
        zoom: 5,
        maxZoom: 20,
        minZoom: 5,
        pitch: INITIAL_PITCH,
        bearing: 0,
        maxPitch: MAX_PITCH,
        minPitch: 0
      }
    }
  }
  
  getDeckGLState = () => {
    return this.state.deckGLInitialState;
  }

  // DeckGL and mapbox will both draw into this WebGL context
  _onWebGLInitialized = (gl) => {
    this.setState({gl});
  }

  // Add deck layer to mapbox
  _onMapLoad = () => {
    const map = this._map;
    const deck = this._deck;
    map.addLayer(new MapboxLayer({id: 'my-scatterplot', deck}));
  }
  
  getPolygon(p){
    let c = p.coordinates.latlon;
    let res = [];
    c.forEach(i => {
      let lonlat = [i[1], i[0], this.getHeightOffset(p)];
      res.push(lonlat);
    });
    return [res]
  }

  getElevation(p){
    return parseFloat(p.height);
  }

  getFillColor(p){
    let status =  this.state.status_array ? this.state.status_array.find(x => x.key == p.status) : null;
    
    if(status){
      return [status.red,status.green,status.blue];
    }
    
    return [108,117,125];
    
  }

  onClick(info, event){
    if(info.object){
      this.hideUpperStories(info);
      this.viewLotDetails(info.object);
    }
  }

  viewLotDetails = (lot) => {
    this.setState({
      action: 'view',
      selected_lot: lot
    })
    this.sendActivityLogRequest(lot['_id'], 'VIEW');
  }

  onHover(info){
    this.setState({
      hoverInfo: info
    });
  }

  onDeckHover(object){
    if(object.object && object.object.name){
      this.setState({
        isHovering: true
      });
    }else{
      this.setState({
        isHovering: false
      });
    }
  }

  getCursor(action){
    const { hoverInfo, gl, isHovering } = this.state;
    
    if(isHovering){
      return 'pointer';
    }

    return action.isDragging ? 'grabbing' : 'grab';
  }

  getMetadata(k, v){
    let label = '';
    let sufix = '';
    switch(k){
      case 'AREA': label = 'Área'; sufix = ' m2'; break;
      case 'PERIMETER': label = 'Perímetro'; sufix = ' m2'; break;
      case 'PROMO': label = 'Promocíón'; sufix = ''; break;
    }

    if(label != ''){
      return (
        <span key={k}>{label}: <b>{v} {sufix}</b><br/></span>
      )
    }
    return (
      <span key={k}></span>
    )
    
  }

  renderPrice(object){
    if(object.price){
      if(object.discount && object.discount > 0){
        return(
          <p className="text-right">
            Reserva con: <b>{methods.G_renderPrice(object.price, 'MXN')}</b><br/>
            Descuento: <b>-{methods.G_renderPrice(object.discount, 'MXN')}</b><br/>
            Final: <b>{methods.G_renderPrice(object.price - object.discount, 'MXN')}</b><br/>
          </p>
        )
      }else{
        return(
          <p>Reserva con: <b>{methods.G_renderPrice(object.price, 'MXN')}</b></p>
        )
      }
    }
  }

  renderSimplePriceAmount = (price) => {
    if(price){
      return(
        methods.G_renderPrice(price, 'MXN')
      )
    }
    return(
      '-'
    )
  }

  renderMetadata(object){
    
    if(object.metadata && object.metadata.length > 0){
      let meta = [];
      for(let j = 0; j < object.metadata.length; j++){
        for (const [key, value] of Object.entries(object.metadata[j])) {
          meta[key] = value;
        }
      }

      let front = meta['FRONT'] ? meta['FRONT'] : null;
      let depth = meta['DEPTH'] ? meta['DEPTH'] : null;
      let area = meta['AREA'] ? meta['AREA'] : null;
      let price_m2 = meta['PRICE_M2'] ? meta['PRICE_M2'] : null;
      let lot_price = null;
      if(area != '-' && price_m2 != null){
        lot_price = parseFloat(area) * parseFloat(price_m2);
        lot_price = lot_price.toFixed(2);
      }

      return (
        <span>
          <p>
            { front && 
              <span>Frente: <b>{front} m</b><br/></span>
            }
            { depth &&
              <span>Fondo: <b>{depth} m</b><br/></span>
            }
            { area && 
              <span>Área: <b>{area} m2</b><br/></span>
            }
            { price_m2 && 
              <span>Precio (m2): <b>{this.renderSimplePriceAmount(price_m2)}</b><br/></span>
            }
            { lot_price && 
              <span>Precio Lote: <b>{this.renderSimplePriceAmount(lot_price)}</b><br/></span>
            }
          </p>
          {this.renderPrice(object)}
        </span>
      );
    }

    return (
        <span>
          {this.renderPrice(object)}
        </span>
      );
  }

  getSeparatorPolygon(p){
    let c = p.coordinates.latlon;
    let res = [];
    c.forEach(i => {
      let lonlat = [i[1], i[0], this.getSeparatorHeightOffset(p)];
      res.push(lonlat);
    });
    return [res]
  }

  getHeightOffset(p){
    if(this.state.development && this.state.development.is_vertical){
      if(p.story_number && p.story_number > 1){
        let stories_below = this.state.stories.filter(x => (x.tower_id == p.tower_id && x.number < p.story_number));
        if(stories_below.length > 0){
          let count_separators = stories_below.length;
          let offset = 0;
          stories_below.forEach(i => {
            offset += i.height;
          });
          return offset + (count_separators * 0.1);
        }
      }
    }

    return 0;
  }

  getSeparatorHeightOffset(p){
    if(this.state.development && this.state.development.is_vertical){
      if(p.story_number && p.story_number > 1){
        let stories_below = this.state.stories.filter(x => (x.tower_id == p.tower_id && x.number < p.story_number));
        if(stories_below.length > 0){
          let count_separators = stories_below.length - 1;
          let offset = 0;
          stories_below.forEach(i => {
            offset += i.height;
          });
          return offset + (count_separators * 0.1);
        }
      }
    }

    return 0;
  }

  hideUpperStories(p){
    let lot = p && p.object ? p.object : null;

    if(this.state.development && this.state.development.is_vertical && lot){
      
      this.state.lots.map((x) => {
        x.enabled = true;
        if(x.tower_id == lot.tower_id && x.story_number > lot.story_number){
          x.enabled = false;
        }
      });

      this.state.separators.map((x) => {
        x.enabled = true;
        if(x.tower_id == lot.tower_id && x.story_number > lot.story_number){
          x.enabled = false;
        }
      });

    }

  }

  enableAllLots(){
    this.state.lots.map((x) => {
      x.enabled = true;
    });
    this.state.separators.map((x) => {
      x.enabled = true;
    });
  }

  getVisibleLots(){
    return this.state.lots.filter(x => x.enabled);
  }

  getVisibleSeparators(){
    return this.state.separators.filter(x => x.enabled);
  }

  getSeparators(lots){
    let separators = lots.map((x) => {
      return {
        height: 0.1,
        tower_id: x.tower_id,
        story_id: x.story_id,
        story_number: x.story_number,
        coordinates: x.coordinates,
        enabled: x.enabled,
      }
    })

    return separators;
  }

  dispatchLots = () => new Promise((resolve, reject) => {

    getStoriesByDevelopment({
      development_id: this.state.development_id
    }).then((res) => {
      let stories = [];
      if (res) {
          stories = res;
      }
      
      getLotsByDevelopment({
        development_id: this.state.development_id
      }).then((res) => {
        let lots = [];
        if (res) {
            let state_lots = this.state.lots;
            lots = res.map((i) => {
              
              let current = state_lots.find(x => x._id == i._id);
              let is_enabled = current ? current.enabled : true;
              return {...i, ...{enabled: is_enabled}}
            });
        }

        let separators = this.getSeparators(lots);

        this.setState({
          lots: lots ,
          stories: stories,
          separators: separators,
        }, () => resolve('lots data ok'));

      });
    });
});
  
  componentDidMount() {
    this.setState({
      loading: true
    });
    getDevelopmentByCode(DEVELOPMENT_CODE).then(
      (res) => {

        localStorage.setItem("pub_dev", JSON.stringify(res));

        const agent = JSON.parse(localStorage.getItem('agent'));
        const openAgentModal2 = agent && agent.user_id && agent.user_code ? false : true;
        let agents = [];
        if(agent && agent.user_id && agent.user_code){
          agents.push(agent);
        }
        
        this.setState({
          modalOpen: false,
          modalOpen2: openAgentModal2,
          loading: true,
          agents: agents,
          selected_agent: agents.length > 0 ? 0 : null,
          user_code: agents.length > 0 ? agents[0].user_code : null,
          development_id: res.development_id,
          development: res,
          deckGLInitialState: {
            longitude: res.longitude,
            latitude: res.latitude,
            zoom: res.zoom,
            maxZoom: res.max_zoom,
            minZoom: res.min_zoom,
            pitch: INITIAL_PITCH,
            bearing: 0,
            maxPitch: MAX_PITCH,
            minPitch: 0
          }
        }, () => {
          Promise.all([this.dispatchLots()]).then(values => {
            
            this.setState({
                loading: false,
            });

          }, reason => {
              console.info(reason)
          });
        });

        this._timer = null;
        clearInterval(this._timer);
        this.startTimer();
      }
    );
    
    getSettingsStatus().then(
      (res) => {
        this.setState({
          status_array: res,
        });
      }
    );
  }

  componentWillUnmount() {
    if (this._timer) {
      clearInterval(this._timer);
      this._timer = null;
    }
  }

  startTimer() {
    var self = this;
    setTimeout(function () {
      self.redo();
      self._timer = setInterval(self.redo.bind(self), 30000);
    }, 500);
  }

  redo() {
    this.refresh();
  }
  
  refresh = () => {
    this.dispatchLots();
  }

  hideModal = () => {
    this.setState({
      modalOpen: false
    });
  }

  showMap3D = () => {
    if(this.state.show2D){
      let deckState = {...this.state.deckGLInitialState, ...{pitch: INITIAL_PITCH, maxPitch: MAX_PITCH}};
      
      this.setState({
        show2D: false,
        polygonExtruded: true,
        deckGLInitialState: deckState
      })
    }else{
      let deckState = {...this.state.deckGLInitialState, ...{pitch: 0, maxPitch: 0}};
      
      this.setState({
        show2D: true,
        polygonExtruded: false,
        deckGLInitialState: deckState
      })
    }
  }

  showModal2 = () => {
    this.setState({
      action: null,
      selected_lot: null,
      selected_agent: null,
      agents: [],
      modalOpen2: true
    });
  }

  hideModal2 = () => {
    this.setState({
      modalOpen2: false
    });
  }

  renderLotsTable = () => {
    let lots = (this.state.lots && this.state.lots.length > 0) ? [...this.state.lots] : [];
    let dev = this.state.development;

    lots.sort(function (a, b) {
      if(dev.is_vertical){
        var aTower = a.tower_number;
        var bTower = b.tower_number;
        var aStory = a.story_number;
        var bStory = b.story_number;
        var aBlock = a.block;
        var bBlock = b.block;
        var aNumber = a.number;
        var bNumber = b.number;
        
        if(aTower == bTower){
          if(aStory == bStory){
            if(aBlock == bBlock){
                return (aNumber < bNumber) ? -1 : (aNumber > bNumber) ? 1 : 0;
            }else{
                return (aBlock < bBlock) ? -1 : 1;
            }
          }else{
              return (aStory < bStory) ? -1 : 1;
          }
        }else{
          return (aTower < bTower) ? -1 : 1;
        }
      }else{
        var aBlock = a.block;
        var bBlock = b.block;
        var aNumber = a.number;
        var bNumber = b.number;
        
        
        if(aBlock == bBlock){
            return (aNumber < bNumber) ? -1 : (aNumber > bNumber) ? 1 : 0;
        }else{
            return (aBlock < bBlock) ? -1 : 1;
        }
      }
    });

    const listLots = lots ? lots.map((i) => {
      const { development } = this.state;

      let info = development && development.is_vertical ? i.story_number : i.block;
      return( 
        <tr className="lot-item" key={i._id} onClick={this.viewLotDetails.bind(this, i)}>
          <td className="lot_name">{i.name}</td>
          <td className="lot_info pr-1">{this.renderStatusLabel(i)}</td>
          <td className="lot_info d-none d-sm-none d-md-table-cell pl-1 pr-1" style={{textAlign: 'center'}}><span className="value">{info}</span></td>
          <td className="lot_info d-none d-sm-none d-md-table-cell pl-1 pr-1" style={{textAlign: 'center'}}><span className="value">{i.number}</span></td>
          <td className="lot_info" style={{textAlign: 'center'}}><span className="value">{this.renderSimplePrice(i)}</span></td>
          
        </tr>
      )
    }) : [];

    if(listLots.length > 0){
      return (
        <Table striped hover>
          <thead>
            <tr>
              <th className="sticky-th">Nombre</th>
              <th className="sticky-th pr-1">Estatus</th>
              { this.state.development && this.state.development.is_vertical &&
                <th className="sticky-th d-none d-sm-none d-md-table-cell pl-1 pr-1" style={{textAlign: 'center'}}>Piso</th>
              }
              { this.state.development && !this.state.development.is_vertical &&
                <th className="sticky-th d-none d-sm-none d-md-table-cell pl-1 pr-1" style={{textAlign: 'center'}}>Mza.</th>
              }
              <th className="sticky-th d-none d-sm-none d-md-table-cell pl-1 pr-1" style={{textAlign: 'center'}}>Núm.</th>
              <th className="sticky-th" style={{textAlign: 'center'}}>Reserva con</th>
            </tr>
          </thead>
          <tbody>
            {listLots}
          </tbody>
        </Table>
      );
    }else{
      return (
        <span>No hay ningún lote configurado.</span>
      );
    }

  }

  renderStatusLabel = (object) => {
    let status =  this.state.status_array ? this.state.status_array.find(x => x.key == object.status) : null;
    let label = status ? status.label : '-';

    let color = this.getFillColor(object);
    color = 'rgb(' + color[0] + ',' + color[1] + ',' + color[2] + ')';

    return (
      //<span style={{backgroundColor: color, color:'white', fontSize:'12px', padding:'3px', borderRadius:'5px'}}>{label}</span>
      <div className="status-label">
        <span className="status-indicator" style={{backgroundColor: color}}></span> <span>{label}</span>
      </div>
    )
  }

  renderSimplePrice = (object) => {
    if(object.price){
      if(object.discount && object.discount > 0){
        let total = object.price - object.discount;
        return(
          <span>{methods.G_renderPrice(total, 'MXN')} *</span>
        )
      }
      return(
        <span>{methods.G_renderPrice(object.price, 'MXN')} </span>
      )
    }
    return(
      <span>-</span>
    )
  }

  closeDetails = () => {
    this.enableAllLots();
    this.setState({
      action: null,
      selected_lot: null,
    });
  }

  getAgentsByCode = () => {
    this.setState({
      selected_agent: null,
      agents: [],
      loading_agents: true,
      error_msg: null,
    });
    if(this.state.user_code && this.state.user_code.length > 0){
      getAgentsByUserCode(this.state.user_code).then((res) => {
        let items = [];
        if (res) {
            items = res;
        }
        this.setState({
          agents: items ,
          loading_agents: false,
          error_msg: items.length > 0 ? '' : 'No se encontraron vendedores. Verifica el código ingresado.',
        });
      });
    }else{
      this.setState({
        loading_agents: false,
        error_msg: 'Ingresa un código válido.',
      });
    }
  }

  onChangeUserCode = (e) => {
    this.setState({
      user_code: e.target.value
    });
  }

  onChangeAgent = (e) => {
    this.setState({
      selected_agent: e.target.value
    });
  }

  renderAgentName = (i) => {
    let label = '';
    
    if(this.state.agents && this.state.agents.length > 0 && this.state.agents[i]){
      const a = this.state.agents[i];
      label = a.first_name ? a.first_name: '' ;
      label += a.last_name ? ' ' + a.last_name : '';
      label += a.last_name_2 ? ' ' + a.last_name_2 : '';
    }
    
    return label;
  }

  renderAgentsSelector = () => {
    let listAgents = [];
    if(this.state.agents && this.state.agents.length > 0){
      listAgents = this.state.agents.map((a, i) => {
        let label = this.renderAgentName(i);
        let k = a.agent_id; 
        let t = a.type
        return (
          <option key={t+'_'+k} value={i}>{label}</option>
        );
      });
    }

    return (
      <select value={this.state.selected_agent != null ? this.state.selected_agent : ''} className="form-control" id="agent_name" onChange={this.onChangeAgent}>
        <option value="">Seleccionar...</option>
        {listAgents}
      </select>
    )
    
  }

  setAgentStorage = () => {
    if(this.state.agents && this.state.agents.length > 0 && this.state.agents[this.state.selected_agent]){
      const a = this.state.agents[this.state.selected_agent];
      localStorage.setItem("agent", JSON.stringify(a));
    }
    this.hideModal2();
  }
  
  showReservationForm = () => {
    this.setState({
      action: 'reserve'
    });

    this.sendActivityLogRequest(this.state.selected_lot['_id'], 'RESERVATION_BUTTON');
  }

  updateLot = (lot) => {
    let index = this.state.lots.findIndex((item) =>lot['_id'] == item['_id']);
    let lots = [...this.state.lots]
    if(index >= 0){
      lots[index] = lot;
      this.setState({
        lots: lots
      });
    }
  }

  getUserCode = () => {
    const agent = JSON.parse(localStorage.getItem('agent'));
    return agent.user_code;
  }

  getAgentIdAndType = () => {
    const agent = JSON.parse(localStorage.getItem('agent'));
    return {
      'agent_id': agent.agent_id,
      'type': agent.type,
      'user_id': agent.user_id,
    };
  }

  showSatelliteMap = () => {
    this.setState({
      showSatelliteMap: !this.state.showSatelliteMap
    });
  }

  getMapViewStyle = () => {
    if(this.state.showSatelliteMap){
      return "mapbox://styles/mapbox/satellite-streets-v11";
    }
    return "mapbox://styles/mapbox/outdoors-v11";
  }

  sendActivityLogRequest = (lot_id, type) => {
    const agent = this.getAgentIdAndType();
    
    let data = {
      user_id: agent.user_id,
      agent: agent.type == 'agent' ? agent.agent_id : null,
      type: type,
    }
    
    addActivityLog({lot_id, data});
  }

  getTootltipStyle = (hoverInfo) => {
    
    let tooltipW = 200;
    let tooltipH = 0;
    if(this.tooltipRef.current){
      tooltipW = this.tooltipRef.current.offsetWidth;
      tooltipH = this.tooltipRef.current.offsetHeight;

      let x_val = hoverInfo.x < this._deck.canvas.width / 2 ? hoverInfo.x + 10 : hoverInfo.x - tooltipW - 10;
      let y_val = hoverInfo.y < this._deck.canvas.height / 2 ? hoverInfo.y + 10 : hoverInfo.y - tooltipH - 10;

      return {pointerEvents: 'none', left: x_val, top: y_val};

    }

    return {pointerEvents: 'none', left: 0, top: 0}
    
  }

  render() {
      const { hoverInfo, gl, lots, loading } = this.state;

      if (loading) {
        return (
          <div className="h-100">
            <NavPublicMenu development={this.state.development} logout={this.showModal2} agents={this.state.agents} selected_agent={this.state.selected_agent} />
            <div className="container-fluid pt-4 h-100">
              Cargando...
            </div>
          </div>
        );
      }

      return (
        <div className="h-100">
          <NavPublicMenu development={this.state.development} logout={this.showModal2} agents={this.state.agents} selected_agent={this.state.selected_agent} />
          <div className="container-fluid h-100 ext-container">
            <div className="row h-100">
              <div className="col-12 col-md-5 col-lg-5 col-xl-4 pt-4 deckgl-container order-2 order-md-1">
                { 
                  this.state.action == null &&
                  this.state.selected_lot == null &&
                  <div>
                    <h3>Lotes</h3>
                    <br/><br/>
                    {this.renderLotsTable()}
                  </div>
                }
                {
                  this.state.action == 'view' &&
                  this.state.selected_lot !== null &&
                  <div>
                    
                    <LotDetails development={this.state.development} lot={this.state.selected_lot} close={this.closeDetails} reserve={this.showReservationForm} status_array={this.state.status_array} />
                    
                  </div>
                }
                {
                  this.state.action == 'reserve' &&
                  this.state.selected_lot !== null &&
                  <div>
                    
                    < ReservationForm action={this.state.action} close={this.closeDetails} development={this.state.development} lot={this.state.selected_lot} lot_id={this.state.selected_lot.lot_id} update={this.updateLot} user_code={this.getUserCode()} agent={this.getAgentIdAndType()} is_agent={true} status_array={this.state.status_array} />
                    
                  </div>
                }
              </div>
              <div className="col-12 col-md-7 col-lg-7 col-xl-8 deckgl-container map-container order-1 order-md-2">
                <Modal
                  show={this.state.modalOpen} 
                  centered
                  >
                  <Modal.Header>
                    <Modal.Title>¡Bienvenido!</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    Para poder continuar, por favor proporciona los siguientes datos:
                    <form>
                      <div className="mt-3 mb-3">
                        <label htmlFor="name" className="form-label">Nombre <span className="required">*</span></label>
                        <input type="text" className="form-control" id="name" />
                      </div>
                      <div className="mt-3 mb-3">
                        <label htmlFor="lastname" className="form-label">Apellido <span className="required">*</span></label>
                        <input type="text" className="form-control" id="lastname" />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="phone" className="form-label">Teléfono <span className="required">*</span></label>
                        <div className="input-group mb-3">
                          <span className="input-group-text" id="phone-addon">+52</span>
                          <input type="text" id="phone" className="form-control" aria-label="Nombre" aria-describedby="phone-addon1" />
                        </div>
                      </div>
                    </form>
                  </Modal.Body>
                  <Modal.Footer>
                    <button className="btn btn-primary" onClick={this.hideModal}>Aceptar</button>
                  </Modal.Footer>
                </Modal>

                <Modal
                  show={this.state.modalOpen2} 
                  centered
                  >
                  <Modal.Header>
                    <Modal.Title>¡Bienvenido!</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    Para poder continuar, por favor proporciona los siguientes datos:
                    <form>
                      <div className="mt-3 mb-3">
                        <label htmlFor="name" className="form-label">Código <span className="required">*</span></label>
                        <div className="input-group mb-3">
                          <input value={this.state.user_code ? this.state.user_code : ''} type="text" className="form-control" id="user_code" aria-describedby="user_code_search_btn" onChange={this.onChangeUserCode} />
                          <button className="btn btn-primary" type="button" id="user_code_search_btn" onClick={this.getAgentsByCode.bind(this)} disabled={this.state.loading_agents}>
                            {this.state.loading_agents && (
                              <span className="spinner-border spinner-border-sm"></span>
                            )}
                            <span>Buscar</span>
                          </button>
                        </div>
                      </div>
                      
                      { this.state.agents && this.state.agents.length > 0 && 
                        <div className="mt-3 mb-3">
                          <label htmlFor="lastname" className="form-label">Nombre <span className="required">*</span></label>
                          {this.renderAgentsSelector()}
                        </div>
                      }

                    </form>
                  </Modal.Body>
                  { this.state.selected_agent != null && 
                    <Modal.Footer>
                      <button className="btn btn-primary" onClick={this.setAgentStorage}>Aceptar</button>
                    </Modal.Footer>
                  }
                  { this.state.error_msg && 
                    <Modal.Footer>
                      <span className="error_message">{this.state.error_msg}</span>
                    </Modal.Footer>
                  }
                </Modal>

                <div className="switch-3D">
                  
                    <Form.Check 
                      type="switch"
                      id="map-view-switch"
                      label="3D"
                      checked={!this.state.show2D}
                      onChange={this.showMap3D}
                    />

                    <Form.Check 
                      type="switch"
                      id="map-view-switch-2"
                      label="Satélite"
                      checked={this.state.showSatelliteMap}
                      onChange={this.showSatelliteMap}
                    />
                  
                </div>

                <DeckGL
                  ref = {ref => {this._deck = ref && ref.deck; }}
                  initialViewState={this.getDeckGLState()}
                  controller={true}
                  onWebGLInitialized={this._onWebGLInitialized}
                  onHover= {object => this.onDeckHover(object)}
                  getCursor= {action => this.getCursor(action)}
                  ContextProvider={MapContext.Provider}
                >
                  <PolygonLayer 
                    id="polygon-layer"
                    data={this.getVisibleLots()} 
                    pickable= {true}
                    stroked= {true}
                    filled= {true}
                    wireframe= {true}
                    extruded= {this.state.polygonExtruded}
                    lineJointRounded= {true}
                    getPolygon= {d => this.getPolygon(d)}
                    getElevation= {d => this.getElevation(d)}
                    getFillColor= {d => this.getFillColor(d)}
                    getLineColor= {[0, 0, 0]}
                    getLineWidth= {1}
                    onClick= {(info, event) => this.onClick(info, event)}
                    onHover={info => this.onHover(info)}
                    material= {{
                      ambient: 0.5,
                      diffuse: 0.6,
                      shininess: 10,
                      specularColor: [30, 30, 30]
                    }}
                  />

                  {this.state.development && this.state.development.is_vertical &&
                    <PolygonLayer 
                      id="separator-layer"
                      data={this.getVisibleSeparators()} 
                      pickable= {true}
                      stroked= {true}
                      filled= {true}
                      wireframe= {true}
                      extruded= {this.state.polygonExtruded}
                      lineJointRounded= {true}
                      getPolygon= {d => this.getSeparatorPolygon(d)}
                      getElevation= {d => this.getElevation(d)}
                      getFillColor= {[0, 0, 0]}
                      getLineColor= {[0, 0, 0]}
                      getLineWidth= {1}
                      material= {{
                        ambient: 0.5,
                        diffuse: 0.6,
                        shininess: 10,
                        specularColor: [30, 30, 30]
                      }}
                    />
                  }
                  
                  {gl && (
                    <StaticMap
                      ref={ref => { this._map = ref && ref.getMap(); }}
                      gl={gl}
                      mapStyle={this.getMapViewStyle()} // mapbox://styles/mapbox/streets-v11, mapbox://styles/mapbox/outdoors-v11, mapbox://styles/mapbox/dark-v10, mapbox://styles/mapbox/satellite-v9
                      mapboxApiAccessToken={MAPBOX_TOKEN}
                      onLoad={this._onMapLoad}
                    />
                  )}
                  {gl && 
                    <NavigationControl style={NAV_CONTROL_STYLE} showCompass={false} />
                  }
                  {hoverInfo && hoverInfo.object && (
                    <div ref={this.tooltipRef} id="tooltip" style={this.getTootltipStyle(hoverInfo)}>
                      <h5>{ hoverInfo.object.name }</h5>
                      {this.renderStatusLabel(hoverInfo.object)}
                      {this.renderMetadata(hoverInfo.object)}
                    </div>
                  )}
                </DeckGL>
              </div>
            </div>
          </div>
        </div>
      );
  }

}

export default Main;
